import { styled, Typography } from '@mui/material'

export const CommentText = styled(Typography)`
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  overflow-wrap: break-word;
  word-break: break-word;
`
